import { Component } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Card, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { FaArrowLeft, FaSave } from "react-icons/fa";
import faqAreasService from "../../api/faq/faqAreasService";
import { hasPerm, getCurrentUser } from '../../common/utils';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

// Wrapper to use hooks in class component
function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class FAQAreasEdit extends Component {
    constructor(props) {
        super(props);
        this.onChangeNome = this.onChangeNome.bind(this);
        this.onChangeDescricao = this.onChangeDescricao.bind(this);
        this.onChangeAtivo = this.onChangeAtivo.bind(this);
        this.saveArea = this.saveArea.bind(this);

        this.state = {
            id: null,
            nome: "",
            descricao: "",
            ativo: true,
            loading: false,
            error: "",
            submitted: false,
            redirect: false
        };
    }

    componentDidMount() {
        if (this.props.params.id) {
            this.getArea(this.props.params.id);
        }
    }

    getArea(id) {
        this.setState({ loading: true });
        faqAreasService.get(id)
            .then(response => {
                this.setState({
                    id: response.data.id,
                    nome: response.data.nome,
                    descricao: response.data.descricao || "",
                    ativo: response.data.ativo,
                    loading: false
                });
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    loading: false,
                    error: "Erro ao carregar dados da área."
                });
            });
    }

    onChangeNome(e) {
        this.setState({ nome: e.target.value });
    }

    onChangeDescricao(e) {
        this.setState({ descricao: e.target.value });
    }

    onChangeAtivo(e) {
        this.setState({ ativo: e.target.checked });
    }

    saveArea(e) {
        e.preventDefault();

        this.setState({ submitted: true, loading: true, error: "" });

        const data = {
            nome: this.state.nome,
            descricao: this.state.descricao,
            ativo: this.state.ativo
        };

        if (this.state.id) {
            faqAreasService.update(this.state.id, data)
                .then(response => {
                    MySwal.fire({
                        title: 'Sucesso!',
                        text: "Área atualizada com sucesso!",
                        icon: 'success',
                        showCloseButton: true,
                    }).then(() => {
                        this.setState({
                            submitted: false,
                            loading: false,
                            redirect: true
                        });
                    });
                })
                .catch(e => {
                    console.log(e);
                    this.setState({
                        submitted: false,
                        loading: false,
                        error: "Erro ao atualizar a área. Verifique os dados e tente novamente."
                    });
                });
        } else {
            faqAreasService.create(data)
                .then(response => {
                    MySwal.fire({
                        title: 'Sucesso!',
                        text: "Área criada com sucesso!",
                        icon: 'success',
                        showCloseButton: true,
                    }).then(() => {
                        this.setState({
                            submitted: false,
                            loading: false,
                            redirect: true
                        });
                    });
                })
                .catch(e => {
                    console.log(e);
                    this.setState({
                        submitted: false,
                        loading: false,
                        error: "Erro ao criar a área. Verifique os dados e tente novamente."
                    });
                });
        }
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to="/programas/faq-areas" />;
        }

        let dados_usuario = getCurrentUser();
        if (!hasPerm('change_programas') && !hasPerm('add_programas') && dados_usuario['tipo_usuario'] !== '') {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col>
                        <h4 className="page-title">
                            {this.state.id ? "Editar Área de FAQ" : "Nova Área de FAQ"}
                        </h4>
                    </Col>
                    <Col className="text-end">
                        <Link to="/programas/faq-areas" className="btn btn-light btn-sm">
                            <FaArrowLeft /> Voltar
                        </Link>
                    </Col>
                </Row>

                <Card>
                    <Card.Body>
                        {this.state.error && (
                            <Alert variant="danger">{this.state.error}</Alert>
                        )}

                        <Form onSubmit={this.saveArea}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            required
                                            value={this.state.nome}
                                            onChange={this.onChangeNome}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ativo</Form.Label>
                                        <Form.Check 
                                            type="switch"
                                            id="ativo-switch"
                                            label={this.state.ativo ? "Sim" : "Não"}
                                            checked={this.state.ativo}
                                            onChange={this.onChangeAtivo}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={this.state.descricao}
                                            onChange={this.onChangeDescricao}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-end">
                                <Button variant="primary" type="submit" disabled={this.state.loading}>
                                    {this.state.loading ? "Salvando..." : (
                                        <>
                                            <FaSave /> Salvar
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withParams(FAQAreasEdit);
